
class Observations {
  // Constructor
  constructor() {

    // Section with CTA
    this.ctaSection = document.querySelector(".cta-section");

    // sections to display
    this.ctaSectionOn = document.querySelectorAll(".cta-section-on");
    /* console.log(this.ctaSectionOn); */
    this.displayCtaButton();

    this.ctaSectionOff = document.querySelectorAll(".cta-section-off");
    /* console.log(this.ctaSectionOff); */
    this.hideCtaButton();
  }

  // Events

  // Functions
  displayCtaButton() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            document.querySelector(".cta-section").style.opacity = "1";
          } else {
            return;
          }
        });
      },
      {
        threshold: 1,
      }
    );

    this.ctaSectionOn.forEach((item) => {
      observer.observe(item);
    });
  }

  hideCtaButton() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            document.querySelector(".cta-section").style.opacity = "0";
          }
        });
      },
      {
        threshold: 1,
      }
    );

    this.ctaSectionOff.forEach((item) => {
      observer.observe(item);
    });
  }
}

export default Observations;
